module.exports = __webpack_public_path__ + "img/warning.ab496668.svg";